import { Controller } from "@hotwired/stimulus"

// Abre a caixa de impressão do navegador. Botão em vez de imprimir sozinho ao
// abrir: quem clicou em "Imprimir" pode só querer conferir a folha na tela.
export default class extends Controller {
  now() {
    window.print()
  }
}
